module.exports = __webpack_public_path__ + "static/media/ps.b48bacad.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Impact/img/ps.jpeg
// module id = 296
// module chunks = 0